<template>

</template>

<script>
export default {
    name: "Layout.vue"
}
</script>

<style scoped>

</style>
